import React from 'react'
import { colors } from '@mobi/component-library/Theme/Common'

export const ConsentText = (
  <span style={{ color: colors.neutral[900] }}>
    I am authorised to provide the personal information available in the identification documents
    and application form (passport, driver's licence, Medicare card); and
    <br />
    <br /> I consent to my personal information being checked with the document issuer or official
    record holder via third party systems for the purpose of confirming my identity.
  </span>
)
